import React from "react";
import Layout from "components/Layout";
import { get_tdk } from "api/server/tdk";
import { Util } from "@xt/xtbase";
import MoreFeatures from "components/Pages/More/MoreFeatures";

const { getOrigin } = Util;

export default function MorePage(props) {
  return (
    <Layout isShowNav={false} isShowFoot={false} useBottomBar={false}>
      <div className="more-page">
        <MoreFeatures />
      </div>
    </Layout>
  );
}

export async function getStaticProps(context) {
  const resolvedUrl = "/more";
  const props = { resolvedUrl: "/more" };
  try {
    const tdkUrl = getOrigin("www") + "/" + context.locale + resolvedUrl;
    const tdk = await get_tdk({
      params: {
        url: tdkUrl,
        languageType: context.locale == "zh-CN" ? "cn" : context.locale == "zh-HK" ? "hk" : context.locale
      },
    });
    props.tdk = tdk || {};
  } catch (error) {
    console.log("get tdk error");
    console.log(error);
    props.tdk = {};
  }
  return {
    props,
    revalidate: 60
  };
}
